import React from 'react';

import { LottieAnimation } from 'components/animation';

import animation from './json/index.plk.json';

type Props = {
  width?: string;
  height?: string;
};

export const Logo: React.FC<Props> = props => {
  return (
    <LottieAnimation
      title="Popeyes Logo"
      data-testid="Popeyes Logo"
      options={{ animationData: animation }}
      ariaRole="img"
      ariaLabel="Popeyes Logo"
      {...props}
    />
  );
};
